import { Component } from '@angular/core';

@Component({
  selector: 'app-connections',
  template: `<div class="empty-tab"><p>Connections — coming soon</p></div>`,
  styles: [`.empty-tab { padding: 40px 24px; color: #909090; font-size: 0.9rem; }`],
})
export class ConnectionsComponent {}
